<template>
    <div class="advanced-search-wrapper">
        <div class="selected-filters-wrapper">
            <div class="filter-wrapper selected-filter" :class="{'apply-background':selectedFindWithValue.key != 'any' && checkIfNotAdvancedSearch}">
                <div class="filter-label">{{$t('With')}}:</div>
                <Multiselect
                    :value="selectedFindWithValue"
                    :options="findWithFilterList"
                    placeholder="Find with"
                    :searchable="true"
                    :close-on-select="true"
                    :allow-empty="false"
                    track-by="key"
                    label="label"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    @select="updatePrimayFilterValueSearchAs('search_as',$event)"
                    style="margin-top: 7px;">
                    <div slot="singleLabel" slot-scope="{ option }">
                        {{ $t(option.label) }}
                    </div>
                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                        <span style="margin-inline-start:12px;">{{ $t(scope.option.label)}}</span>
                    </div>
                    <span slot="noResult">No results.</span>
                </Multiselect>
            </div>
            <div v-if="!['ticket-display'].includes(searchContext)" class="filter-wrapper selected-filter" :class="{'apply-background':selectedFindInValue.key != 'any' && checkIfNotAdvancedSearch}">
                <div class="filter-label">{{$t('In')}}:</div>
                <Multiselect
                    :value="selectedFindInValue"
                    :options="findInFilterList"
                    placeholder="Find in"
                    :searchable="true"
                    :close-on-select="true"
                    :allow-empty="false"
                    track-by="key"
                    label="label"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    @select="updatePrimayFilterValueSearchIn('search_in',$event)"
                    style="margin-top: 7px;">
                    <div slot="singleLabel" slot-scope="{ option }">
                        {{ $t(option.label) }}
                    </div>
                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                        <span style="margin-inline-start:12px;">{{ $t(scope.option.label)}}</span>
                    </div>
                    <span slot="noResult">No results.</span>
                </Multiselect>
            </div>
            <template v-for="globalfilter in globalFilters">
                <div :key="globalfilter.key" v-if="globalfilter.key == 'mime_type'" class="filter-wrapper selected-filter" :class="{'apply-background':selectedMimeTypeValue.length && checkIfNotAdvancedSearch}">
                    <div class="filter-label">{{ $t(globalfilter.name) }}:</div>
                    <Multiselect
                        v-model="selectedMimeTypeValue" 
                        :options="globalfilter.values"
                        ref="mimeTypeField"
                        :multiple="true"
                        track-by="value_id"
                        label="value"
                        :close-on-select="true"
                        :show-no-results="false"
                        placeholder=""
                        deselectLabel=""
                        selectLabel=""
                        selectedLabel=""
                        :hideSelected="false"
                        :showNoOptions="false"
                        @remove="removeSelectedMimeTypeFilterFromTag($event)"
                        @select="selectMimeTypeFilter($event,globalfilter.values)">
                        <span slot="noResult">No results</span>
                        <span slot="noOptions" style="display:none"></span>
                        <div slot="tag" slot-scope="option" class="selected-tags-style">
                        <div class="tags-display-style">{{$t(option.option.value)}}</div>
                            <div class="remove-tag" v-on:click="removeSelectedMimeTypeFilterFromTag(option.option)">
                                <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                            </div>
                        </div>
                        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                        <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeMimeTypeFilterCheckboxAction(scope.option)" @focus.prevent :key="scope.option.value"/>
                        <span style="margin-inline-start:12px;">{{ $t(scope.option.value) }}</span>
                        </div>
                    </Multiselect>
                </div>
                <div :key="globalfilter.key" v-if="globalfilter.key == 'created_on'" class="filter-wrapper selected-filter" :class="{'apply-background':Object.keys(selectedCreatedDateValue).length && checkIfNotAdvancedSearch}">
                    <div class="filter-label">{{$t('Created on')}}:</div>
                    <date-picker
                            v-if="['after_date','before_date','on_date'].includes(selectedCreatedDateValue.value_id)"
                            :range="false"
                            v-model="createdDateCustomFilterValSingleVal"
                            @input="updatePrimayCreatedOnSingleSelectFilterValue('created_on',createdDateCustomFilterValSingleVal,selectedCreatedDateValue.value_id)"
                            :clearable="false"
                            valueType="format"
                            ref="createdOnSingle"
                            placeholder=''
                            class="text-light comm-input-field-style"
                            style="padding: 0px;border-radius: 5px;position:relative;top:0px;width:170px !important"
                            >
                            <template slot="input" slot-scope="{ picker }">
                            {{selectedCreatedDateValue.value}} {{createdDateCustomFilterValSingleVal}} {{ picker }}
                            </template>
                    </date-picker>
                    <date-picker
                            v-click-outside='hidePicker'
                            v-else-if="selectedCreatedDateValue.value_id == 'year_range'"
                            range
                            v-model="createdDateCustomFilterValForYearRange"
                            @input="updatePrimayCreatedOnFilterValue('created_on',createdDateCustomFilterValForYearRange,selectedCreatedDateValue.value_id,'year')"
                            :clearable="false"
                            valueType="format"
                            ref="createdOnYearRange"
                            placeholder=''
                            type="year"
                            format="YYYY"
                            :max-year="getCurrentYear()"
                            class="text-light comm-input-field-style"
                            style="padding: 0px;border-radius: 5px;position:relative;top:0px;width:210px"
                            @clear="selectedCreatedDateValue = {}"
                    ></date-picker>
                    <date-picker
                        v-click-outside='hidePicker'
                        v-else-if="selectedCreatedDateValue.value_id == 'range'"
                        range
                        v-model="createdDateCustomFilterVal"
                        @input="updatePrimayCreatedOnFilterValue('created_on',createdDateCustomFilterVal,selectedCreatedDateValue.value_id)"
                        :clearable="false"
                        valueType="format"
                        ref="createdOnRange"
                        placeholder=''
                        class="text-light comm-input-field-style"
                        style="padding: 0px;border-radius: 5px;position:relative;top:0px;width:210px"
                        @clear="selectedCreatedDateValue = {}"
                ></date-picker>
                    <Multiselect
                        v-else
                        v-model="selectedCreatedDateValue"
                        :options="globalfilter.values"
                        placeholder=""
                        :searchable="true"
                        :close-on-select="true"
                        :allow-empty="false"
                        track-by="value_id"
                        label="value"
                        deselectLabel=""
                        selectLabel=""
                        selectedLabel=""
                        @select="updateCreatedOnFilter('created_on',$event)"
                        style="margin-top: 7px;">
                        <div slot="singleLabel" slot-scope="{ option }">
                            {{ option.value }}
                        </div>
                        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <span style="margin-inline-start:12px;">{{ $t(scope.option.value)}}</span>
                        </div>
                        <span slot="noResult">No results.</span>
                    </Multiselect>
                    <remove-field v-if="Object.keys(selectedCreatedDateValue).length" @click.native="selectedCreatedDateValue = {}, createdDateCustomFilterValSingleVal = null, createdDateCustomFilterVal = null,createdDateCustomFilterValForYearRange = null, delete completeFormData['created_on'], formData()" style="height: 30px;color: #a9a9a9" :style="['after_date','before_date','on_date','range','year_range'].includes(selectedCreatedDateValue.value_id)?'width:30px':'width:60px'"></remove-field>
                </div>
            </template>
            <div v-for="filter in selectedFiltersList" :key="filter.key"  v-click-outside="removeSelectedClass" class="selected-filter">
                <template v-if="filter.type == 'PICKLIST_MULTIVALUE'">
                    <div v-if="filter.key == 'tag_id'" :id="filter.key" class="filter-wrapper" :class="{focusTheField:autoFocusedField == filter.key,'apply-background':checkIfNotAdvancedSearch}">
                        <div class="filter-label">{{$t(filter.name)}} :</div>
                        <tags-dropdown :ref="filter.key" :selectedTagIds="updatedTagsList" :componentUUID="filter.key" @updatedBulkTagsList="bulkTagsFindCollectionOnSelect" @updatedTagsList="tagsFindCollectionOnSelect" @removedTagsFromList="tagsFindCollectionOnRemove" from="Advanced Search"></tags-dropdown>
                        <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                    </div>
                    <div v-else-if="filter.key == 'catalog_id'" :id="filter.key" class="filter-wrapper" :class="{focusTheField:autoFocusedField == filter.key,'apply-background':checkIfNotAdvancedSearch}">
                        <div class="filter-label">{{$t(filter.name)}} :</div>
                        <CatalogDropdown 
                        :ref="filter.key" 
                        :componentUUID="filter.key" 
                        :enableCatBrowser="false"
                         :selectedCatalogIds="updatedFilteredCatalogsList"
                         from="Advanced Search"
                        @removedCatalogFromList="removedCatalogFromList"
                        @updatedCatalogsList="updatedCatalogsListComp" class="catalog-filter"></CatalogDropdown>
                        <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                    </div>
                    <div v-else-if="filter.key == 'label_id'" :id="filter.key" class="filter-wrapper" :class="{focusTheField:autoFocusedField == filter.key,'apply-background':checkIfNotAdvancedSearch}">
                        <div class="filter-label">{{$t(filter.name)}} :</div>
                        <labelsMultiselect :ref="filter.key" :componentUUID="filter.key" 
                         from="Advanced Search" :selectedLabelsId="updatedLabelsList"
                         @updatedLabelsList="labelsFindCollectionOnSelect" @removedLabelsFromList="labelsFindCollectionOnRemove" class="catalog-filter"></labelsMultiselect>
                        <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                    </div>
                    <div v-else class="filter-wrapper" :id="filter.key" :class="{focusTheField:autoFocusedField == filter.key,'apply-background':checkIfNotAdvancedSearch}">
                        <div class="filter-label">{{$t(filter.name)}} :</div>
                        <Multiselect
                            :value="multiPicklistMapper[filter.key]"
                            :options="filter.values"
                            :ref="filter.key"
                            :multiple="true"
                            :close-on-select="false"
                            :show-no-results="false"
                            track-by="value_id"
                            label="value"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            :placeholder="customisePlaceholder(filter.name,'Select')"
                            :hideSelected="false"
                            :showNoOptions="false"
                            class="multi-tags-select"
                            @select="multiPicklistValueTypeOnSelect($event, filter.key,filter.filter_type)"
                            @remove="multiPicklistValueTypeOnRemove($event, filter.key,filter.filter_type)"
                            :searchable="true">
                            <div slot="tag" slot-scope="option" class="selected-tags-style">
                                <div class="tags-display-style">{{$t(option.option.value)}}</div>
                                    <div class="remove-tag" v-on:click="multiPicklistValueTypeOnRemove(option.option,filter.key,filter.filter_type)">
                                        <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePicklistCheckBoxSelection(scope.option,filter.key)" @focus.prevent :key="scope.option.value_id"/>
                                <span style="margin-inline-start:12px;">{{ $t(scope.option.value) }}</span>
                            </div>
                        </Multiselect>
                        <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                    </div>
                </template>
                <div v-if="filter != undefined && (filter.type == 'FREETEXT' || filter.type == 'FREETEXT_MULTILINE')" :id="filter.key" class="filter-wrapper" :class="{'apply-background':checkIfNotAdvancedSearch}">
                    
                    <div class="filter-label">{{$t(filter.name)}} :</div>
                    <input
                        type="text"
                        :ref="filter.key"
                        style="position:relative;top:0px;"
                        class="rounded text-light comm-input-field-style"
                        :placeholder="customisePlaceholder(filter.name,'Enter')"
                        :value="filter.filter_type == 'field' ? completeFormData['fields'][filter.key] : completeFormData[filter.key]"
                        @input="filter.filter_type == 'field' ? 
                            $event.target.value.length ? 
                                completeFormData['fields'][filter.key] = $event.target.value : delete  completeFormData['fields'][filter.key] : 
                            $event.target.value.length == 0 ?
                                delete completeFormData[filter.key] : completeFormData[filter.key] = $event.target.value"
                        autocomplete="off"
                        @keyup.enter="formData(),applyBackgroundForInputTextField[filter.key] && applyBackgroundForInputTextField[filter.key].length != 0?applyBackgroundForInputTextField[filter.key] = true:applyBackgroundForInputTextField[filter.key] = false"
                        @blur="!checkIfNotAdvancedSearch ? formData() : null"
                    />
                    <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                </div>
                <div v-if="filter != undefined && filter.type == 'DATE'" :id="filter.key" class="filter-wrapper" :class="{'apply-background':checkIfNotAdvancedSearch}">
                    <div class="filter-label">{{$t(filter.name)}} :</div>
                    <date-picker
                                range
                                v-model="dateMappper[filter.key]"
                                @input="updateDateValue(filter.filter_type,dateMappper[filter.key],filter.key, filter.type)"
                                :ref="filter.key"
                                :clearable="false"
                                valueType="format"
                                :placeholder="customisePlaceholder(filter.name,'Enter')"
                                class="text-light comm-input-field-style"
                                style="padding: 0px;border-radius: 5px;position:relative;top:0px"
                                @close="dateMappper[filter.key] && dateMappper[filter.key].length > 0?formData():''"
                    ></date-picker>
                    <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                </div> 
                <div v-if="filter != undefined && filter.type == 'DATE_TIME'" :id="filter.key" class="filter-wrapper"  :class="{'apply-background':checkIfNotAdvancedSearch}">
                    <div class="filter-label">{{$t(filter.name)}} :</div>
                    <date-picker
                                range
                                v-model="dateMappper[filter.key]"
                                @input="updateDateValue(filter.filter_type,dateMappper[filter.key],filter.key, filter.type)"
                                :ref="filter.key"
                                :clearable="false"
                                type="datetime"
                                valueType="format"
                                :placeholder="customisePlaceholder(filter.name,'Enter')"
                                class="text-light comm-input-field-style"
                                style="padding: 0px;border-radius: 5px;position:relative;top:0px"
                                @close="dateMappper[filter.key] && dateMappper[filter.key].length > 0?formData():''"
                                confirm
                    ></date-picker>
                    <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                </div> 
                <div v-if="filter != undefined && filter.type == 'INTEGER'" :id="filter.key" class="filter-wrapper"  :class="{'apply-background':checkIfNotAdvancedSearch}">
                    <div class="filter-label">{{$t(filter.name)}} :</div>
                    <input
                        type="number"
                        :ref="filter.key"
                        style="position:relative;top:0px"
                        class="rounded text-light comm-input-field-style"
                        :placeholder="customisePlaceholder(filter.name,'Enter')"
                        v-model="integerMapper[filter.key]"
                        @input="customiseIntegerPostDataBasedOnType(filter.filter_type,$event.target.value,filter.key)"
                        autocomplete="off"
                        @keyup.enter="formData()"
                        @blur="!checkIfNotAdvancedSearch ? formData() : null"
                    />
                    <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                </div>
                <div v-if="filter != undefined && filter.type == 'users'" :id="filter.key" class="filter-wrapper"  :class="{'apply-background':checkIfNotAdvancedSearch}">
                    <div class="filter-label">{{$t(filter.name)}}
                         :</div>
                    <users-multiselect :ref="filter.key" :componentUuid="filter.key" :enableCheckbox="true" :isSearchable="true" :selectedUserIdList="usersFilterMapper[filter.key]" @updatedUsersList='updatedUsersList' @removedUserFromList='removedUserFromList'></users-multiselect>
                    <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;width: 50px;color: #a9a9a9;"></remove-field>
                </div>
                <template v-if="filter != undefined && filter.type == 'PICKLIST'">
                    <div v-if="filter.key == 'catalog_id'" :id="filter.key" class="filter-wrapper" :class="{focusTheField:autoFocusedField == filter.key,'apply-background':checkIfNotAdvancedSearch}">
                        <div class="filter-label">{{$t(filter.name)}} :</div>
                        <CatalogDropdown 
                        :selectedOptions="selectedCatalogPIcklist" 
                        @updatedCatalogsList="updatedCatalogsList" 
                        :allowSingleSelect="true"
                        style="width:100%;margin-inline-end: 6px;"
                        :ref="filter.key" 
                        :componentUUID="filter.key" 
                        :enableCatBrowser="false"
                        from="Advanced Search"
                        class="catalog-filter"></CatalogDropdown>
                        <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                    </div>
                    <div v-else-if="filter != undefined && filter.type == 'PICKLIST' && filter.key == 'duration'" class="filter-wrapper comm-custom-range-fields" :class="{'apply-background':appliedLabel && appliedLabel.length}">
                        <div class="filter-label">{{$t(filter.name)}} :</div>
                        <div class="dropdown" v-click-outside="closeDurationDropdown">
                            <div
                                class="dropdown-header"
                                :class="{ active: appliedLabel }"
                                @click.stop="toggleDropdown('duration')"
                            >
                            <span :style="appliedLabel?'color:#fff':'color:#5d5d5d'">
                                {{ appliedLabel || $t('Select duration') }}
                            </span>

                            <div style="display:flex;align-items:center;gap:10px;margin-inline-start: 8px;position: relative;top: 1px;">
                                <i v-if="!open" class="bi bi-caret-down-fill" style="font-size: 11px;color: #999;"></i>
                                <i v-if="open" class="bi bi-caret-up-fill" style="font-size: 11px;color: #999;"></i>
                            </div>
                            </div>

                            <div v-if="open" class="dropdown-list">
                            
                                <template v-for="opt in filter.values">    
                                    <div
                                        v-if="opt.value != 'Custom duration range'"
                                        :key="opt.value_id"
                                        class="option"
                                        @click.stop="selectDurationOption(opt)"
                                    >
                                        {{ opt.value }}
                                    </div>
                                </template>    

                                <div class="custom-row" @click.stop="openCustom('duration')">
                                    {{$t('Custom duration range')}}
                                </div>

                                <div v-if="customOpen" @mousedown.stop @click.stop>

                                    <div class="inputs">
                                    <input v-model="min" type="number" :placeholder="$t('From')">
                                    <input v-model="max" type="number" :placeholder="$t('To')">

                                    <select v-model="unit">
                                        <option value="Sec">{{$t('Sec')}}</option>
                                        <option value="Min">{{$t('Min')}}</option>
                                        <option value="Hr">{{$t('Hr')}}</option>
                                    </select>
                                    </div>

                                    <div class="actions">
                                        <button class="btn cancel" @click="cancel('duration')">{{$t('Cancel')}}</button>
                                        <button class="btn apply" @click="apply">{{$t('Apply')}}</button>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <remove-field v-if="appliedLabel" class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                    </div>
                    <div v-else-if="filter != undefined && filter.type == 'PICKLIST' && filter.key == 'size'" class="filter-wrapper comm-custom-range-fields" :class="{'apply-background':appliedSizeLabel && appliedSizeLabel.length}">
                        <div class="filter-label">{{$t(filter.name)}} :</div>
                        <div class="dropdown"  v-click-outside="closeSizeDropdown">
                            <div
                                class="dropdown-header"
                                :class="{ active: appliedSizeLabel }"
                                @click.stop="toggleDropdown('size')"
                            >
                            <span :style="appliedSizeLabel?'color:#fff':'color:#5d5d5d'">
                                {{ appliedSizeLabel || $t('Select Size') }}
                            </span>

                            <div style="display:flex;align-items:center;gap:10px;margin-inline-start: 8px;position: relative;top: 1px;">
                                <i v-if="!sizeOpen" class="bi bi-caret-down-fill" style="font-size: 11px;color: #999;"></i>
                                <i v-if="sizeOpen" class="bi bi-caret-up-fill" style="font-size: 11px;color: #999;"></i>
                            </div>
                            </div>

                            <div v-if="sizeOpen" class="dropdown-list">
                            
                                <template v-for="opt in filter.values">    
                                    <div
                                        v-if="opt.value != 'Custom size range'"
                                        :key="opt.value_id"
                                        class="option"
                                        @click="selectSizeOption(opt)"
                                    >
                                        {{ opt.value }}
                                    </div>
                                </template>    

                                <div class="custom-row" @click.stop="openCustom('size')">
                                    {{$t('Custom size range')}}
                                </div>

                                <div v-if="sizeCustomOpen" @mousedown.stop @click.stop>

                                    <div class="inputs">
                                    <input v-model="sizeMin" type="number" :placeholder="$t('From')">
                                    <input v-model="sizeMax" type="number" :placeholder="$t('To')">

                                    <select v-model="sizeUnit">
                                        <option value="KB">{{$t('KB')}}</option>
                                        <option value="MB">{{$t('MB')}}</option>
                                        <option value="GB">{{$t('GB')}}</option>
                                    </select>
                                    </div>

                                    <div class="actions">
                                        <button class="btn cancel" @click="cancel('size')">{{$t('Cancel')}}</button>
                                        <button class="btn apply" @click="applySize">{{$t('Apply')}}</button>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <remove-field v-if="appliedSizeLabel" class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                    </div>


                    <div v-else :id="filter.key" class="filter-wrapper"  :class="{'apply-background':checkIfNotAdvancedSearch}">
                        <div class="filter-label">{{$t(filter.name)}} :</div>
                        <Multiselect
                            v-model="singlePicklistMapper[filter.key]"
                            :options="filter.values"
                            :ref="filter.key"
                            :placeholder="customisePlaceholder(filter.name,'Select')"
                            :searchable="true"
                            :close-on-select="true"
                            :allow-empty="false"
                            track-by="value_id"
                            class="single-selection"
                            label="value"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            @select="picklistSingleSelect(filter.key,$event,filter.filter_type)"
                            style="margin-top: 7px;">
                            <div slot="singleLabel" slot-scope="{ option }">
                                {{ $t(option.value) }}
                            </div>
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <span style="margin-inline-start:12px;">{{ $t(scope.option.value)}}</span>
                            </div>
                            <span slot="noResult">No results.</span>
                        </Multiselect>
                        <remove-field @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                    </div>
                </template>
            </div>
             <div class="add-search-filter selected-filter filter-wrapper" @click="openSearchFilters('filtersField')">
                 <!-- <div class="add-fileds-icon">Add field</div> -->
                <div v-if="changeTextOfAddField != undefined && changeTextOfAddField.length && checkIfNotAdvancedSearch" class="filter-label" style="margin-inline-start: 40px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill mb-1" viewBox="0 0 16 16">
                        <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
                    </svg>{{changeTextOfAddField}}</div>
                <div v-else class="filter-label" style="margin-inline-start: 40px">
                    <svg v-if="checkIfNotAdvancedSearch" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill mb-1" viewBox="0 0 16 16">
                        <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
                    </svg>{{$t(searchContext == 'query-builder-in-reports'?'More parameters':'More filter')}}</div>
                 <Multiselect
                    v-model="selectedFiltersList" 
                    :options="filtersList"
                    ref="filtersField"
                    :multiple="true"
                    track-by="key"
                    label="name"
                    :close-on-select="true"
                    :show-no-results="false"
                    placeholder=""
                    deselectLabel =""
                    selectLabel=""
                    selectedLabel=""
                    :hideSelected="false"
                    :showNoOptions="false"
                    @open="changeTextOfAddField = searchContext == 'query-builder-in-reports'?'Search parameter':'Select filter'"
                    @close="changeTextOfAddField = searchContext == 'query-builder-in-reports'?'Add parameter':'Add filter'"
                    @remove="removeSelectedFilter($event)"
                    @select="selectFilter($event)">
                    <span slot="noResult">No results</span>
                    <span slot="noOptions" style="display:none"></span>
                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                    <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeFiltersCheckboxAction(scope.option)" @focus.prevent :key="scope.option.name"/>
                    <span style="margin-inline-start:12px;">{{ $t(scope.option.name) }}</span>
                    </div>
                </Multiselect>
            </div>
            <div v-if="checkIfNotAdvancedSearch" @click="resetFields()" class="reset-button">{{$t('Reset')}}</div>
            <div v-if="['mainComp'].includes(compType) && !['projects-display','ticket-display'].includes(searchContext) && checkIfNotAdvancedSearch" @click="enableAddFav = true" class="reset-button">{{$t('Save')}}</div>
        </div>
        <addSavedSearch ref="addOrEditFav" v-if="enableAddFav" v-bind="currentProperties" @close="enableAddFav=false" @validateSearchQuery="validatedSearchQuery"></addSavedSearch>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapActions, mapMutations, mapGetters} from "vuex";
import TagDropDownComponent from "../tags/TagsSelectionDropdown.vue";
import CatalogDropdown from "../categories/CatalogMultiselectDropdown.vue";
import UsersMultiselect  from "../users/UserMultiselectField.vue";
import DatePicker from "vue2-datepicker";
import RemoveField from "../core/InlineCancelField.vue";
import {NotifierConstants} from "../../components.constants.js";
// import Utils from '../../components.utils';
import labelsMultiselect from "../../components/labels/LabelsMultiselectDropdown.vue";
import addSavedSearch from "../Favorites/AddOrEditBookMark.vue";

export default {
    props:["searchContext", "compType","appliedValues","searchContextPaylod","pluginSpecificSearchInFilters"],
    data(){
        return{
            routeQuery:[],
            filtersList:[],
            selectedFilter:{},
            selectedFiltersList:[],
            updatedTagsList:[],
            updatedLabelsList:[],
            usersFilterMapper:{},
            completeFormData:{"fields":{}},
            updatedFilteredCatalogsList:[],
            show:false,
            autoFocusedField:"",
            multiPicklistMapper:{},
            singlePicklistMapper:{},
            integerMapper:{},
            dateMappper:{},
            changeTextOfAddField:"",
            fieldLength:80,
            selectedFindWithValue:{"label":"Any word","key":"any"},
            findWithFilterList:[
                {"label":"Any word","key":"any"},
                {"label":"All words","key":"all"},
                {"label":"Exact word","key":"exact"},
            ],
            selectedFindInValue:{"label":"Any","key":"any"},
            findInFilterList:[
                {"label":"Any","key":"any"},
                // {"label":"Slug name","key":"slug_name"},
                {"label":"File name","key":"file_name"},
                {"label":"Description","key":"description"},
                {"label":"Content","key":"content"}
            ],
            selectedMimeTypeValue:[],
            mimeTypeOptionsArr:[],
            selectedCreatedDateValue:{},
            createdDateCustomFilterValSingleVal:null,
            createdDateCustomFilterVal:null,
            createdDateCustomFilterValForYearRange:null,
            createdDateOptionsArr:[],
            globalFilters:[],
            openCreatedOnDatePicker:false,
            applyBackgroundForInputTextField:{},
            enableAddFav:false,
            valuesToBePopulated:{},
            selectedCatalogPIcklist:'',
            
            open: false,
            customOpen: false,
            appliedLabel: '',
            min: '',
            max: '',
            unit: 'Sec',
            sizeOpen: false,
            sizeCustomOpen: false,
            appliedSizeLabel: '',
            sizeMin: '',
            sizeMax: '',
            sizeUnit: 'KB',
        }
    },
    components:{
        "Multiselect":Multiselect,
        "tags-dropdown":TagDropDownComponent,
        "users-multiselect":UsersMultiselect,
        CatalogDropdown,
        "date-picker":DatePicker,
        "remove-field":RemoveField,
        labelsMultiselect,
        addSavedSearch
    },
    computed:{
        checkIfNotAdvancedSearch(){
            if(this.searchContext == 'query-builder-in-reports'){
                return false;
            }
            return true;
        },
        currentProperties() {
            return {favInfo : {name:"",type:"Saved Search"}, newFav:"true"}
        },
        barcodeInfoFromStartup:{
            get(){
                return this.$store.state.startUpData.startUpDataDetails;
            }
        },
    },
    methods:{
        //Generic----------------------------------------------------------
        getCurrentYear(){
            return new Date().getFullYear()
        },
        hidePicker(){
            this.openCreatedOnDatePicker = false;
        },
        customisePlaceholder(name,prefix){
            return `${prefix +" "+ name}`;
        },
        acceptOnlyNumbers(event){
            let regex = new RegExp(/^[0-9]|[-]$/);
            let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        },
        //-----------------------------------------------------------------
        //Filters dropdown construction----------------------------------------------
        selectFilter(option){
            let index = this.filtersList.findIndex(item => item.key == option.key);
                 if(index > -1){
                     this.filtersList[index].checked = true;
                    //  this.selectedFiltersList.push(option);
                     this.$nextTick(() => {
                         let autoFocusedField = option.key;
                         setTimeout(() => {
                                if (this.$refs[autoFocusedField]) {
                                    this.autoFocusInputFields(autoFocusedField,option.type)
                                }
                         }, 200);
                     })
                 }
        },
        autoFocusInputFields(keyName,custMetadataType){
            document.getElementsByClassName('focusTheField').forEach(el => el.classList.remove("focusTheField"))
            if(keyName == 'catalog_id'){
                this.$refs[keyName][0].$el.firstElementChild.firstElementChild.focus();
            }
            if(['INTEGER','FREETEXT','FREETEXT_MULTILINE',"DATE","DATE_TIME"].includes(custMetadataType)){
                this.$refs[keyName][0].focus();
            }
            if(['PICKLIST_MULTIVALUE','PICKLIST','users','tags'].includes(custMetadataType)){
                setTimeout(() => {
                    this.$refs[keyName][0].$el.focus();
                }, 200);
            }
            document.getElementById(keyName).classList.add("focusTheField");
        },
        removeFilter(option){
            let index = this.filtersList.findIndex(item => item.key == option.key);
                 if(index > -1){
                     this.filtersList[index].checked = false;
                 }
        },
        makeFiltersCheckboxAction(option){
            return this.selectedFiltersList.some((op) => op.key === option.key);
        },
        //Mimetype filter----------------------------------------------------------
        makeMimeTypeFilterCheckboxAction(option){
                return this.selectedMimeTypeValue.some((op) => op === option);
        },

        selectMimeTypeFilter(selectedOption,optionsArr){
            let index = optionsArr.findIndex(item => item.value_id == selectedOption.value_id);
                 if(index > -1){
                     optionsArr[index].checked = true;
                 }
                 setTimeout(() => {
                        this.completeFormData['mime_type'] = JSON.stringify(this.getOnlyValuesOfMimetypes(this.selectedMimeTypeValue));
                        this.formData();
                 }, 200);
        },

        removeSelectedMimeTypeFilter(selectedOption,optionsArr){
            let index = optionsArr.findIndex(item => item.value_id == selectedOption.value_id);
            if(index > -1){
                optionsArr[index].checked = false;
            }
            this.completeFormData['mime_type'] = JSON.stringify(this.getOnlyValuesOfMimetypes(this.selectedMimeTypeValue));
            if(this.selectedMimeTypeValue.length == 0){
                delete this.completeFormData['mime_type'];
            }
            this.formData();
        },
        removeSelectedMimeTypeFilterFromTag(selectedOption){
            this.selectedMimeTypeValue = this.selectedMimeTypeValue.filter(e => e.value_id != selectedOption.value_id);
            this.completeFormData['mime_type'] = JSON.stringify(this.getOnlyValuesOfMimetypes(this.selectedMimeTypeValue));
            if(this.selectedMimeTypeValue.length == 0){
                delete this.completeFormData['mime_type'];
            }
            this.formData();
        },
        getOnlyValuesOfMimetypes(arr){
            let temp = [];
            for(let i = 0; i<arr.length;i++){
                temp.push(arr[i].value_id);
            }
            return temp;
        },
        //---------------------------------------------------------------------------
        //Picklist Multivalue-----------------------------------------------------------
        multiPicklistValueTypeOnSelect(option,key,type){
            if(type =='field'){
                if(this.completeFormData["fields"][key] == undefined){
                    this.completeFormData["fields"][key] = [];
                }else{
                    this.completeFormData["fields"][key];
                }
                this.completeFormData["fields"][key].push(option.value_id);
                let temp = this.$refs[key][0].value;
                let indx = temp.findIndex(op=>op.value_id == option.value_id);
                if(indx < 0){
                    temp.push(option);
                    this.$set(this.$refs[key][0], "value", temp)
                    this.$forceUpdate();
                    // this.$refs[key][0].value = temp
                }
                // this.$set(this.multiPicklistMapper[key],this.completeFormData["fields"][key])
                // if(this.multiPicklistMapper && Object.keys(this.multiPicklistMapper).includes(key)){
                //     this.multiPicklistMapper[key].push(option);
                // }else{
                //     this.multiPicklistMapper[key] = [option]
                // }
                this.formData();
            }else{
                if(this.completeFormData[key] == undefined){
                    this.completeFormData[key] = [];
                }else{
                    this.completeFormData[key] = JSON.parse(this.completeFormData[key])
                }
                this.completeFormData[key].push(option.value_id);
                this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
                this.formData(true,key);
            }
        },
        multiPicklistValueTypeOnRemove(option,key,type){
            if(type =='field'){
                this.completeFormData["fields"][key] = this.completeFormData["fields"][key].filter(e => e != option.value_id);
                if(this.completeFormData["fields"][key].length == 0){
                    delete this.completeFormData["fields"][key];
                }
                // this.$refs[key][0].value = this.$refs[key][0].value.filter(op=>op.value_id != option.value_id);
                if(this.$refs[key] && this.$refs[key].length > 0){
                    let indx = this.$refs[key][0].value.findIndex(op=>op.value_id == option.value_id);
                    if(indx >= 0){
                        this.$refs[key][0].value.splice(indx, 1);
                        this.$forceUpdate();
                        this.makePicklistCheckBoxSelection(option,key)
                    }
                }

                this.formData();
            }else{
                this.completeFormData[key] = JSON.parse(this.completeFormData[key])
                this.completeFormData[key] = this.completeFormData[key].filter(e => e != option.value_id);
                if(this.completeFormData[key].length == 0){
                    delete this.completeFormData[key];
                }else{
                    this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
                }
                this.formData();
            }
        },
        removeSelectedPicklistOption(value,key,type){
            if(type =='field'){
                this.completeFormData["fields"][key] = this.completeFormData["fields"][key].filter(e => e != value.value_id);
                if(this.completeFormData["fields"][key].length == 0){
                    delete this.completeFormData["fields"][key];
                }
                this.$refs[key][0].value = this.$refs[key][0].value.filter(op=>op.value_id != value.value_id);
            }else{
                this.completeFormData[key] = JSON.parse(this.completeFormData[key])
                this.completeFormData[key] = this.completeFormData[key].filter(e => e != value.value_id);
                if(this.completeFormData[key].length == 0){
                    delete this.completeFormData[key];
                }else{
                    this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
                }
            }
            this.multiPicklistMapper[key] = this.multiPicklistMapper[key].filter(e => e.value_id != value.value_id);
            this.formData();
        },
        makePicklistCheckBoxSelection(option,key){
            if(this.$refs[key] && this.$refs[key].length > 0 && this.$refs[key][0].value != undefined){
                return this.$refs[key][0].value.some((op) => op.value_id == option.value_id);
            }
            return false;
        },
        //---------------------------------------------------------------------

         //**********Duration and Size custom fields************** */
         toggleDropdown(type) {
            if (type === 'duration') {
                // toggle duration
                this.open = !this.open

                // always close size
                this.sizeOpen = false
                this.sizeCustomOpen = false
            }

            if (type === 'size') {
                // toggle size
                this.sizeOpen = !this.sizeOpen

                // always close duration
                this.open = false
                this.customOpen = false
            }
        },

        closeDurationDropdown() {
            this.open = false;
            this.customOpen = false;
        },

        closeSizeDropdown(){
            this.sizeOpen = false;
            this.sizeCustomOpen = false;
        },

        selectDurationOption(opt) {
            this.appliedLabel = opt.value;
            this.open = false;
            this.customOpen = false;
            let durationValue = {};
            
            durationValue["type"] = opt.value_id;
            this.completeFormData['duration'] = durationValue;
            this.formData();
        },

        selectSizeOption(opt) {
            this.appliedSizeLabel = opt.value
            this.sizeOpen = false
            this.sizeCustomOpen = false;
            let sizeValue = {};
            
            sizeValue["type"] = opt.value_id;
            this.completeFormData['size'] = sizeValue;
            this.formData();
        },

        openCustom(type) {
            if(type == 'duration'){
                this.customOpen = true;
            }else if(type == 'size'){
                this.sizeCustomOpen = true;
            }    
        },

        cancel( type) {
            if(type == 'duration'){
                this.customOpen = false;
            }else if(type == 'size'){
                this.sizeCustomOpen = false;
            }
        },

        apply() {
            const hasMin = this.min !== '';
            const hasMax = this.max !== '';

            if (!hasMin && !hasMax) {
                this.appliedLabel = '';
                delete this.completeFormData['duration'];
                alert(this.$t('Please enter either minimum Duration or maximum Duration'));
                return;
            }

            if (hasMin && hasMax && Number(this.max) < Number(this.min)) {
                this.appliedLabel = '';
                delete this.completeFormData['duration'];
                alert(this.$t('From value cannot be greater than To value'));
                return;
            }

            const minLabel = hasMin ? `${this.min} ${this.unit}` : `0 ${this.unit}`;
            const maxLabel = hasMax ? `${this.max} ${this.unit}` : this.$t('onwards');

            this.appliedLabel = `${minLabel} – ${maxLabel}`;

            this.open = false;
            this.customOpen = false;

            let durationValue = {};
            durationValue["type"] = 'range';
            if(this.min){
                durationValue["from_value"] = parseInt(this.min);
            }    
            if(this.max){
                durationValue["to_value"] = parseInt(this.max);
            }    
            durationValue["unit"] = this.unit;
            this.completeFormData['duration'] = durationValue;
            this.formData();
        },

        applySize() {
            const hasMin = this.sizeMin !== '';
            const hasMax = this.sizeMax !== '';

            if (!hasMin && !hasMax) {
                this.appliedSizeLabel = '';
                delete this.completeFormData['size'];
                alert(this.$t('Please enter either minimum size or maximum size'));
                return;
            }

            if (hasMin && hasMax && Number(this.sizeMax) < Number(this.sizeMin)) {
                this.appliedSizeLabel = '';
                delete this.completeFormData['size'];
                alert(this.$t('From value cannot be greater than To value'));
                return;
            }

            const minLabel = hasMin ? `${this.sizeMin} ${this.sizeUnit}` : `0 ${this.sizeUnit}`;
            const maxLabel = hasMax ? `${this.sizeMax} ${this.sizeUnit}` : this.$t("Onwards");
            
            this.appliedSizeLabel = `${minLabel} – ${maxLabel}`;

            this.sizeOpen = false;
            this.sizeCustomOpen = false;

            let sizeValue = {};
            sizeValue["type"] = 'range';
            if(this.sizeMin){
                sizeValue["from_value"] = parseInt(this.sizeMin)
            }   
            if(this.sizeMax){
                sizeValue["to_value"] = parseInt(this.sizeMax);
            }    
            sizeValue["unit"] = this.sizeUnit;
            this.completeFormData['size'] = sizeValue;
            this.formData();

            // this.$emit('change', {
            //     min: this.min,
            //     max: this.max,
            //     unit: this.unit
            // })
        },

        clearFilter() {
            this.appliedLabel = ''
            this.min = ''
            this.max = ''
            this.unit = this.units[0]
            this.$emit('change', null)
        },

        onDurationChange(val) {
            console.log('Duration Filter:', val)
        },

        onSizeChange(val) {
            console.log('Size Filter:', val)
        },

        //**********end of duration and size custom fields************** */

        picklistSingleSelect(key,value,type){
            if(type =='field'){
                this.completeFormData['fields'][key] = value.value_id;
                this.$refs[key][0].value = value
            }else{
                this.completeFormData[key] = value.value_id;
            }
            this.formData();
        },
        //Users-------------------------------------------------------------------
        updatedUsersList(option,key){
            if(!this.completeFormData[key]){
                this.completeFormData[key] = [];
            }else{
                this.completeFormData[key] = JSON.parse(this.completeFormData[key])
            }
            this.completeFormData[key].push(option);
            this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
            console.log("optionoption",option,key, this.completeFormData[key])
            this.formData();
        },
        removedUserFromList(option,key){
            this.completeFormData[key] = JSON.parse(this.completeFormData[key])
            this.completeFormData[key] = this.completeFormData[key].filter(e => e != option);
            if(this.completeFormData[key].length == 0){
                delete this.completeFormData[key];
            }else{
                this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
            }
            this.formData();
        },
        //----------------------------------------------------------
        //Tags--------------------------------------------------------
        bulkTagsFindCollectionOnSelect(bulkTagIds,key){
            this.updatedTagsList = bulkTagIds;
            this.completeFormData[key] = JSON.stringify(this.updatedTagsList);
            this.formData();
        },
        tagsFindCollectionOnSelect(option,key){
            if(!this.updatedTagsList.includes(option._id)){
                this.updatedTagsList.push(option._id);
            }
            this.completeFormData[key] = JSON.stringify(this.updatedTagsList);
            this.formData();
        },
        tagsFindCollectionOnRemove(option, key){
            this.completeFormData[key] = JSON.parse(this.completeFormData[key])
            this.completeFormData[key] = this.completeFormData[key].filter(e => e != option._id);
            this.updatedTagsList = this.completeFormData[key];
            if(this.completeFormData[key].length == 0){
                delete this.completeFormData[key];
            }else{
                this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
            }
            this.formData();
        },
        //--------------------------------------------------------------
        //Labels--------------------------------------------------------
        labelsFindCollectionOnSelect(option,key){
            if(!this.updatedLabelsList.includes(option._id)){
                this.updatedLabelsList.push(option._id);
            }
            this.completeFormData[key] = JSON.stringify(this.updatedLabelsList);
            this.formData();
        },
        labelsFindCollectionOnRemove(option, key){
            this.completeFormData[key] = JSON.parse(this.completeFormData[key])
            this.completeFormData[key] = this.completeFormData[key].filter(e => e != option._id);
            this.updatedLabelsList = this.completeFormData[key];
            if(this.completeFormData[key].length == 0){
                delete this.completeFormData[key];
            }else{
                this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
            }
            this.formData();
        },
        //--------------------------------------------------------------
        //Catalogs------------------------------------------------------
        updatedCatalogsListComp(option,key){
            this.updatedFilteredCatalogsList.push(option._id);
            this.completeFormData[key] = JSON.stringify(this.updatedFilteredCatalogsList);
            this.formData();
        },
        removedCatalogFromList(option, key){
            this.completeFormData[key] = JSON.parse(this.completeFormData[key])
            this.completeFormData[key] = this.completeFormData[key].filter(e => e != option._id);
            this.updatedFilteredCatalogsList = this.completeFormData[key];
            if(this.completeFormData[key].length == 0){
                delete this.completeFormData[key];
            }else{
                this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
            }
            this.formData();
        },
        updatedCatalogsList(option,key){
            this.completeFormData[key] = option._id;
            this.formData();
        },
        //Date----------------------------------------------------------------------------------------------
        updateDateValue(type,value,key, filterType){
            let fVal = value[0];
            let tVal = value[1];
            if(!fVal || !tVal){
                alert("Please select date range");
                return false;
            }
            if(filterType == 'DATE_TIME'){
                fVal = fVal.replace(" ","T");
                tVal = tVal.replace(" ", "T");
            }
            let temp = {'from_value':fVal,'to_value':tVal};
            if(type == 'field'){
                this.completeFormData['fields'][key] = temp;
            }else{
                this.completeFormData[key] = temp;
            }
        },
        //---------------------------------------------------------------------------------------------------
        //Integer--------------------------------------------------------------------------------------------
        customiseIntegerPostDataBasedOnType(type,value,key){
            let temp = null;
            this.integerMapper[key] = value;
            if(value.includes('-')){
                temp = value.split("-");
                temp = {'from_value':parseInt(temp[0]),'to_value':parseInt(temp[1])};
            }else{
                temp = parseFloat(value)
            }
            if(type == 'field'){
                this.completeFormData['fields'][key] = temp;
                if(isNaN(this.completeFormData['fields'][key]) || this.completeFormData['fields'][key].length == 0){
                    delete this.completeFormData['fields'][key];
                }
            }else{
                this.completeFormData[key] = temp;
                if(isNaN(this.completeFormData[key]) || this.completeFormData[key].length == 0){
                    delete this.completeFormData[key];
                }
            }
        },
        filterLabelCallback(){
            return `${'More' +" + "}`
        },
        getfiltersListOnContext(workspaceCntx){
                let payload = {};
                let context = String(workspaceCntx).toLowerCase()
                if(context == 'query-builder-in-reports' && this.getQueryBuiderQueryParamters()){
                    if(this.searchContextPaylod && Object.keys(this.searchContextPaylod).length > 0){
                        payload = this.searchContextPaylod;
                        this.getSearchActionsFromServer(payload).then((data) => {
                            let slugFilter = {"label":"Slug name","key":"slug_name"};
                            let findMediaSlugInFilters = data.filters.find(e => e.key == 'slug_name');
                            if(findMediaSlugInFilters){
                                slugFilter.label = findMediaSlugInFilters.name;
                            }
                            this.findInFilterList.splice(1,0,slugFilter)
                            this.filtersList = data.filters;
                            let fIndex = this.filtersList.findIndex(e => e.key == 'search_in');
                            if(fIndex > -1){
                                this.findInFilterList = this.filtersList[fIndex].values.map(item => ({
                                    key: item.value_id,
                                    label: item.value
                                }));
                                this.filtersList = this.filtersList.filter(e => e.key != 'search_in');
                            }
                            this.reloadRouteFilters();
                            if(data.global_filters){
                                this.globalFilters = data.global_filters;
                            }else{
                                this.globalFilters = []
                            }
                        this.reloadAdvanceSearchFilters();
                        })
                    }else{
                        let slugFilter = {"label":"Slug name","key":"slug_name"};
                        let findMediaSlugInFilters = this.getQueryBuiderQueryParamters().filters.find(e => e.key == 'slug_name');
                        if(findMediaSlugInFilters){
                            slugFilter.label = findMediaSlugInFilters.name;
                        }
                        this.findInFilterList.splice(1,0,slugFilter)
                        this.filtersList = this.getQueryBuiderQueryParamters().filters;
                        if(this.getQueryBuiderQueryParamters().global_filters){
                            this.globalFilters = this.getQueryBuiderQueryParamters().global_filters;
                        }else{
                            this.globalFilters = []
                        }
                        this.reloadAdvanceSearchFilters();
                    }
                }else{
                    if(context == 'bins'){
                        payload = {name:"bin_workspace"}
                    }else if(context == 'catalogs-display' || context == 'media-pipeline-stage'){
                        payload = {name:"catalog_workspace"}
                    }if(this.searchContextPaylod && Object.keys(this.searchContextPaylod).length > 0){
                        payload = this.searchContextPaylod
                    }
                    if(!payload || Object.keys(payload).length == 0){
                        return;
                    }
                    this.getSearchActionsFromServer(payload).then((data) => {
                        let slugFilter = {"label":"Slug name","key":"slug_name"};
                        let findMediaSlugInFilters = data.filters.find(e => e.key == 'slug_name');
                        if(findMediaSlugInFilters){
                            slugFilter.label = findMediaSlugInFilters.name;
                        }
                        this.findInFilterList.splice(1,0,slugFilter)
                        this.filtersList = data.filters;
                        let fIndex = this.filtersList.findIndex(e => e.key == 'search_in');
                        if(fIndex > -1){
                            this.findInFilterList = this.filtersList[fIndex].values.map(item => ({
                                key: item.value_id,
                                label: item.value
                            }));
                            this.filtersList = this.filtersList.filter(e => e.key != 'search_in');
                        }
                        this.reloadRouteFilters();
                        if(data.global_filters){
                            this.globalFilters = data.global_filters;
                        }else{
                            this.globalFilters = []
                        }
                    this.reloadAdvanceSearchFilters();
                    })   

                }
        },
        updatePrimayCreatedOnFilterValue(key,value,type,filterType=null){
            if(filterType && filterType == 'year'){
                let fVal = value[0];
                let tVal = value[1];
                this.completeFormData[key] = {"type":type,'from_value':fVal+'-01-01','to_value':tVal+'-12-31'};
            }else{
                let fVal = value[0];
                let tVal = value[1];
                this.completeFormData[key] = {"type":type,'from_value':fVal,'to_value':tVal};
            }
            this.formData();
        },
        updatePrimayCreatedOnSingleSelectFilterValue(key,value,type){
            switch(type) {
                case 'on_date':
                    this.completeFormData[key] = {'type':'on_date','value':value};
                    break;
                case 'before_date':
                    this.completeFormData[key] = {'type':'before_date','to_value':value};
                    break;
                case 'after_date':
                    this.completeFormData[key] = {'type':'after_date','from_value':value};
                    break;
            }
            this.formData();
        },
        updateCreatedOnFilter(key,value){
            if(key == 'created_on'){
                switch(value.value_id) {
                    case 'today_date':
                        this.completeFormData[key] =  {"type":"today_date"};
                        break;
                    case 'yesterday_date':
                        this.completeFormData[key] =  {"type":"yesterday_date"};
                        break;
                    case 'last_week':
                        this.completeFormData[key] =  {"type":"last_week"};
                        break;
                    case 'last_one_hr':
                        this.completeFormData[key] =  {"type":"last_one_hr"};
                        break;
                    case 'on_date':
                    case 'before_date':
                    case 'after_date':
                        setTimeout(() => {
                            if(this.$refs["createdOnSingle"])this.$refs["createdOnSingle"][0].focus();
                        }, 600);
                        break;
                    case 'range':
                        setTimeout(() => {
                            if(this.$refs["createdOnRange"])this.$refs["createdOnRange"][0].focus();
                        }, 600);
                        break;
                    case 'year_range':
                        setTimeout(() => {
                            if(this.$refs["createdOnYearRange"])this.$refs["createdOnYearRange"][0].focus();
                        }, 600);
                        break;
                }
            }else{
                this.completeFormData[key] = value.key;
            }
            this.$nextTick(() =>{
                this.formData();
            })
        },
        updatePrimayFilterValueSearchAs(key,value){
            this.selectedFindWithValue = value;
            if(value.key == "any"){
                delete this.completeFormData['search_as'];
            }else{
                    if((this.$route.query && Object.keys(this.$route.query).includes("keyword") && this.$route.query.keyword.length) ||
                        (this.compType && ["subComp"].includes(this.compType) && document.getElementById("gloabl_search_in_file_browse") && document.getElementById("gloabl_search_in_file_browse").value.length)){
                        this.completeFormData[key] = value.key;
                    }else if(!this.checkIfNotAdvancedSearch && this.$parent && this.$parent.$refs && this.$parent.$refs.query_keyword && this.$parent.$refs.query_keyword.value && this.$parent.$refs.query_keyword.value.trim().length){
                        this.completeFormData[key] = value.key;
                    }else{
                        alert("This filter cannot be applied if keyword search is empty");
                        setTimeout(() => {
                            this.selectedFindWithValue = {"label":"Any word","key":"any"};
                        }, 200);
                        return
                    }
            }
            this.formData();
            
        },
        updatePrimayFilterValueSearchIn(key,value){
            this.selectedFindInValue = value;
            if(value.key == "any"){
                delete this.completeFormData['search_in'];
            }else{
                    if((this.$route.query && Object.keys(this.$route.query).includes("keyword") && this.$route.query.keyword.length)
                        || (this.compType && ["subComp"].includes(this.compType)  && document.getElementById("gloabl_search_in_file_browse") && document.getElementById("gloabl_search_in_file_browse").value.length)){
                            this.completeFormData[key] = JSON.stringify([value.key]);
                    }else if(!this.checkIfNotAdvancedSearch && this.$parent && this.$parent.$refs && this.$parent.$refs.query_keyword && this.$parent.$refs.query_keyword.value && this.$parent.$refs.query_keyword.value.trim().length){
                        this.completeFormData[key] =JSON.stringify([value.key]);
                    }else{
                        alert("This filter cannot be applied if keyword search is empty");
                        setTimeout(() => {
                            this.selectedFindInValue = {"label":"Any","key":"any"};  
                        }, 200);
                        return
                    }
            }
            this.formData();
        },
        fetchGlobalFiltersSearchData(){
            let tempForm = {}
            for(let eachFilter of this.globalFilters){
                if(eachFilter.key == "created_on" && this.selectedCreatedDateValue &&
                   "value_id" in this.selectedCreatedDateValue){
                    tempForm[eachFilter.key] = {type:this.selectedCreatedDateValue["value_id"]}
                    if(["before_date"].includes(tempForm[eachFilter.key].type)){
                        tempForm[eachFilter.key]["to_value"] = this.createdDateCustomFilterValSingleVal
                    }else if(["on_date"].includes(tempForm[eachFilter.key].type)){
                        tempForm[eachFilter.key]["value"] = this.createdDateCustomFilterValSingleVal
                    }else if(["after_date"].includes(tempForm[eachFilter.key].type)){
                        tempForm[eachFilter.key]["from_value"] = this.createdDateCustomFilterValSingleVal
                    }else if(["range"].includes(tempForm[eachFilter.key].type) && this.createdDateCustomFilterVal){
                        tempForm[eachFilter.key]["from_value"] = this.createdDateCustomFilterVal[0]
                        tempForm[eachFilter.key]["to_value"] = this.createdDateCustomFilterVal[1]
                    }else if(["year_range"].includes(tempForm[eachFilter.key].type) && this.createdDateCustomFilterValForYearRange){
                        tempForm[eachFilter.key]["from_value"] = this.createdDateCustomFilterValForYearRange[0]+'-01-01'
                        tempForm[eachFilter.key]["to_value"] = this.createdDateCustomFilterValForYearRange[1]+'-12-31'
                    }
                }else if(eachFilter.key == "mime_type" && this.selectedMimeTypeValue &&
                    this.selectedMimeTypeValue.length){
                    let mimeList = []
                    for(let eachMime of this.selectedMimeTypeValue){
                        if(!mimeList.includes(eachMime.value_id)){
                            mimeList.push(eachMime.value_id)
                        }
                    }
                    if(mimeList.length){
                        tempForm[eachFilter.key] = JSON.stringify(mimeList)
                    }
                }
            }
            if(this.selectedFindInValue && 'key' in this.selectedFindInValue && this.selectedFindInValue.key != "any"){
                tempForm['search_in'] = `["${this.selectedFindInValue.key}"]`
            }
            if(this.selectedFindWithValue && 'key' in this.selectedFindWithValue && this.selectedFindWithValue.key != "any"){
                tempForm['search_as'] = `${this.selectedFindWithValue.key}`
            }
            return tempForm
        },
        formData(forceEmit = false){
            let tempForm = this.completeFormData
            for(let eachGF of Object.keys(this.fetchGlobalFiltersSearchData())){
                tempForm[eachGF] = this.fetchGlobalFiltersSearchData()[eachGF]
            }
            this.$emit("advancedSearchData",tempForm);
            if(!forceEmit)this.reloadRouteFilters();
        },
        validatedSearchQuery(){
            this.$refs["addOrEditFav"].validatedQuery(this.returnFormData(true))
        },
        returnFormData(includeKeyword = false){
            if(includeKeyword){
                let searchQuery = {}
                let routeQuery = this.$route.query
                let keywordFilter = ""
                if(routeQuery && 'keyword' in routeQuery){
                    keywordFilter = routeQuery.keyword
                }
                if (keywordFilter.trim().length){
                    searchQuery["keyword"] = keywordFilter
                }
                let tempFilters = this.completeFormData
                for(let eachGF of Object.keys(this.fetchGlobalFiltersSearchData())){
                    tempFilters[eachGF] = this.fetchGlobalFiltersSearchData()[eachGF]
                }
                searchQuery["advanceFilter"] = tempFilters
                if(Object.keys(searchQuery).length){
                    return searchQuery
                }else{
                    alert("Default query is not allowed to save.")
                    return null
                }
            }
            return this.completeFormData;
        },
        resetFields(forceReset = false){
            this.selectedFiltersList = [];
            this.updatedTagsList = [];
            this.updatedLabelsList = [];
            this.updatedFilteredCatalogsList = [];  
            this.completeFormData = {'fields':{}};
            this.dateMappper = {};
            this.selectedFindWithValue = {"label":"Any word","key":"any"};
            this.selectedFindInValue = {"label":"Any","key":"any"};
            this.selectedMimeTypeValue = [];
            this.selectedCreatedDateValue = {};
            this.multiPicklistMapper = {};
            this.usersFilterMapper = {};
            this.singlePicklistMapper = {};
            this.integerMapper = {};
            this.dateMappper = {};
            if(!forceReset){
                this.formData();
            }
        },
        removeSelectedFilter(option,doNotCallGet=false){
            let tempKey = option.key;
            this.selectedFiltersList = this.selectedFiltersList.filter(e => e.key != option.key);
            this.emptyTheFields(tempKey)
            if(option.key == 'duration'){
                this.appliedLabel = '';
                this.min = '';
                this.max = '';
                this.unit = 'Sec';
            }
            if(option.key == 'size'){
                this.appliedSizeLabel = '';
                this.sizeMin = '';
                this.sizeMax = '';
                this.sizeUnit = 'KB';
            }
            if(option.filter_type == 'field'){
                delete this.completeFormData["fields"][tempKey];
            }else{
                delete this.completeFormData[tempKey];
            }
            this.$nextTick(() => {
                if(!Object.keys(this.completeFormData).includes("fields")){
                    this.completeFormData['fields'] = {};
                }
            })
            if(!doNotCallGet)this.formData();
        },
        removeSelectedClass(){
            document.getElementsByClassName('focusTheField').forEach(el => el.classList.remove("focusTheField"))
        },
        emptyTheFields(tempKey){
            if(this.multiPicklistMapper[tempKey] && this.multiPicklistMapper[tempKey].length){
                this.multiPicklistMapper[tempKey] = []
            }else if(this.singlePicklistMapper[tempKey] && Object.keys(this.singlePicklistMapper[tempKey]).length){
                this.singlePicklistMapper[tempKey] = '';
            }else if(this.integerMapper[tempKey]){
                this.integerMapper[tempKey] = null
            }else if(this.dateMappper[tempKey]){
                this.dateMappper[tempKey] = null;
            }else if(this.completeFormData["fields"][tempKey]){
                this.completeFormData["fields"][tempKey] = '';
            }else if(tempKey == 'tag_id'){
                this.updatedTagsList = [];
            }else if(tempKey == 'catalog_id'){
                this.updatedFilteredCatalogsList = [];
            }else if(tempKey == 'label_id'){
                this.updatedLabelsList = [];
            }else if(this.usersFilterMapper[tempKey] && this.usersFilterMapper[tempKey].length){
                this.usersFilterMapper[tempKey] = [];
            }
        },
        openSearchFilters(){
            this.$refs.filtersField.$el.focus();
        },
        updateFieldLength(value){
            if(value != undefined){
                if(value > 2){
                    this.fieldLength = (value.length + 1)*8;
                }else{
                    this.fieldLength = (value.length + 4)*8;
                }
            }
        },
        handleFieldsNotificaionInAdvancedSearch(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let field_info = notification.message;
                    if (notification.message_type == NotifierConstants.fieldCreatedNotification){
                        field_info['key'] = field_info._id;
                        field_info['filter_type'] = 'field';
                        this.filtersList.push(field_info);
                    }
                    if(notification.message_type == NotifierConstants.fieldModifiedNotification){
                        let field = this.filtersList.filter((e_)=>e_.key == field_info._id);
                        if (field.length != 0){
                            field = field[0]
                            Object.assign(field, field_info)
                        }
                    }
                    if(notification.message_type == NotifierConstants.fieldRemovedNotification){
                        this.filtersList = this.filtersList.filter((e_)=>e_.key != field_info._id);
                        let selectedFieldsIndex = this.selectedFiltersList.findIndex(item => item.key == field_info._id);
                             field_info['key'] = field_info._id;
                             field_info['filter_type'] = 'field';
                            if(selectedFieldsIndex > -1){
                                    this.$toast.info("Selected" +field_info.name+ "is deleted by other user")
                                    this.removeSelectedFilter(field_info,true);
                            }
                    }
            }
        },
        registerforWebsocketNotifications(){
            this.addWSEventListener({
                    eventname:[NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification],
                    callback:this.handleFieldsNotificaionInAdvancedSearch,
                    parent:"AdvancedSearch"})
            },
        unRegisterforWebsocketNotifications(){
            this.removeWSEventListener({
                    eventname:[NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification],
                    callback:this.handleFieldsNotificaionInAdvancedSearch,
                    parent:"AdvancedSearch"})
            },
        reloadRouteFilters(){
            if(this.appliedValues){
                this.valuesToBePopulated = this.appliedValues;
            }else{
                this.valuesToBePopulated = this.$route.query;
            }
            let query = Object.assign({}, this.valuesToBePopulated)
            if(query && 'advanceFilter' in this.valuesToBePopulated && this.valuesToBePopulated){
                let tempAdvanceFilter  = Object.keys(JSON.parse(query.advanceFilter));
                if(Object.keys(query).includes("keyword") && query.keyword.trim().length && tempAdvanceFilter.includes('search_as')){
                    let indexA = this.findWithFilterList.findIndex(e => e.key == JSON.parse(query.advanceFilter)['search_as']);
                    if(indexA > -1)this.selectedFindWithValue = this.findWithFilterList[indexA]
                }else if(!this.checkIfNotAdvancedSearch && this.$parent && this.$parent.$refs && this.$parent.$refs.query_keyword && this.$parent.$refs.query_keyword.value && this.$parent.$refs.query_keyword.value.trim().length && tempAdvanceFilter.includes('search_as')){
                    let indexA = this.findWithFilterList.findIndex(e => e.key == JSON.parse(query.advanceFilter)['search_as']);
                    if(indexA > -1)this.selectedFindWithValue = this.findWithFilterList[indexA]
                }else{
                    this.selectedFindWithValue = {"label":"Any word","key":"any"}
                }

                if(Object.keys(query).includes("keyword") && query.keyword.trim().length && tempAdvanceFilter.includes('search_in')){
                    let indexB = this.findInFilterList.findIndex(e => e.key == JSON.parse(JSON.parse(query.advanceFilter)['search_in'])[0]);
                    if(indexB > -1){
                        this.selectedFindInValue = this.findInFilterList[indexB]
                    }
                }else if(!this.checkIfNotAdvancedSearch && this.$parent && this.$parent.$refs && this.$parent.$refs.query_keyword && this.$parent.$refs.query_keyword.value && this.$parent.$refs.query_keyword.value.trim().length && tempAdvanceFilter.includes('search_in')){
                    let indexB = this.findInFilterList.findIndex(e => e.key == JSON.parse(JSON.parse(query.advanceFilter)['search_in'])[0]);
                    if(indexB > -1){
                        this.selectedFindInValue = this.findInFilterList[indexB]
                    }
                }else{
                    this.selectedFindInValue = {"label":"Any","key":"any"}
                }
                this.routeQuery = JSON.parse(query.advanceFilter);
                // if(('search_as' in tempAdvanceFilter || 'search_in' in tempAdvanceFilter) && !Object.keys(query).includes("keyword")){
                //     this.formData(true)
                // }
            }
        },
        reloadAdvanceSearchFilters(){
            if(this.routeQuery.fields)this.routeQuery.fields = JSON.parse(JSON.stringify(this.routeQuery.fields));
            this.selectedFiltersList = []
            if(![undefined,null].includes(this.routeQuery) && Object.keys(this.routeQuery).length > 0){
                this.integerMapper = {};
                this.completeFormData.fields = {}
                let loadedList = [];
                for(let op of this.filtersList){
                    let entrySelected = false;
                    if(!loadedList.includes(op.key)){
                        loadedList.push(op.key)
                    }else{
                        //duplicated key i.e already fetched this key details
                        continue
                    }
                    if(op.filter_type == "field" && 'fields' in this.routeQuery &&
                         ![undefined,null].includes(this.routeQuery.fields) &&
                          op._id in this.routeQuery.fields &&
                          ![undefined,null].includes(this.routeQuery.fields[op._id])
                          && Object.keys(this.routeQuery.fields)){
                        entrySelected = true;
                        let fOpVal = this.routeQuery.fields[op._id]
                        if(op.type == "INTEGER"){
                            this.integerMapper[op._id] = fOpVal;
                        }else if(op.type == "PICKLIST"){
                            let valOp = op.values.filter(e=>e.value_id == fOpVal)
                            if(valOp.length > 0){
                                this.singlePicklistMapper[op._id] = valOp[0]
                            }
                            this.completeFormData.fields[op._id] = fOpVal;
                        }else if(op.type == "PICKLIST_MULTIVALUE"){
                            let array = [];
                            for(let i =0; i< fOpVal.length; i++){
                                let index = op.values.findIndex(e=>e.value_id == fOpVal[i]);
                                if(index > -1){
                                    array.push(op.values[index])
                                }
                            }
                            this.multiPicklistMapper[op._id] = array;
                        }else if(["DATE"].includes(op.type)){
                            this.dateMappper[op._id] = [fOpVal.from_value, fOpVal.to_value]
                        }else if(["DATE_TIME"].includes(op.type)){
                            let fVal = fOpVal.from_value;
                            fVal = fVal.replace("T"," ")
                            let tVal = fOpVal.to_value;
                            tVal = tVal.replace("T"," ")
                            this.dateMappper[op._id] = [fVal, tVal]
                        }
                        this.completeFormData.fields[op._id] = fOpVal;
                    }else if(op.filter_type == "metadata"){
                        if(op.key in this.routeQuery
                                && ![undefined,null].includes(this.routeQuery[op.key]) && this.routeQuery[op.key].length){
                            entrySelected = true;
                            if(['catalog_id','tag_id','label_id'].includes(op.key)){
                                let tOpVal = JSON.parse(this.routeQuery[op.key]);
                                if(op.key == 'tag_id'){
                                    this.updatedTagsList = tOpVal;
                                }else{
                                    this.updatedFilteredCatalogsList = tOpVal;
                                }
                                this.completeFormData[op.key] = this.routeQuery[op.key];
                            }else if(['slug_name', "description"].includes(op.key)){
                                this.completeFormData[op.key] = this.routeQuery[op.key];
                            }
                        }else{
                            if(op.key == 'tag_id'){
                                this.updatedTagsList = [];
                            }else if(op.key == 'catalog_id'){
                                this.updatedFilteredCatalogsList = [];
                            }
                        }
                    }else if(op.filter_type == "default" && op.key in this.routeQuery
                                && ![undefined,null].includes(this.routeQuery[op.key])){
                        entrySelected = true;
                        let fOpVal = this.routeQuery[op.key]
                        if(['type','mime_type'].includes(op.key)){
                            let tVal = op.values.filter(r=>r.value_id == this.routeQuery[op.key])
                            if(tVal.length > 0){
                                this.singlePicklistMapper[op.key] = tVal[0]
                            }
                        }else if(op.key == 'label_id'){
                            this.updatedLabelsList = JSON.parse(fOpVal);
                        }else if(op.type == 'PICKLIST' && op.key == 'catalog_id'){
                            this.selectedCatalogPIcklist = this.routeQuery['catalog_path_info'];
                        }else if(op.type == 'users'){
                            this.usersFilterMapper[op.key] = JSON.parse(fOpVal);
                        }else if(['created_on','updated_on'].includes(op.key)){
                            this.dateMappper[op.key] = [fOpVal.from_value, fOpVal.to_value];
                        }else if(op.key == 'duration'){      
                            if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type != 'range'){
                                let optionObj = op.values.find(e=>e.value_id == fOpVal.type);
                                this.appliedLabel = optionObj.value;
                            }else if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type == 'range'){
                                this.min = fOpVal.from_value ? fOpVal.from_value: "";
                                this.max = fOpVal.to_value ? fOpVal.to_value : "";
                                this.unit = fOpVal.unit;

                                const hasMin = this.min !== '';
                                const hasMax = this.max !== '';

                                if (!hasMin && !hasMax) {
                                    this.appliedLabel = '';
                                    delete this.completeFormData['duration'];
                                    alert(this.$t('Please enter either minimum Duration or maximum Duration'));
                                    return;
                                }

                                if (hasMin && hasMax && Number(this.max) < Number(this.min)) {
                                    this.appliedLabel = '';
                                    delete this.completeFormData['duration'];
                                    alert(this.$t('From value cannot be greater than To value'));
                                    return;
                                }

                                const minLabel = hasMin ? `${this.min} ${this.unit}` : `0 ${this.unit}`;
                                const maxLabel = hasMax ? `${this.max} ${this.unit}` : this.$t('onwards');

                                this.appliedLabel = `${minLabel} – ${maxLabel}`;
                            }
                        }else if(op.key == 'size'){      
                            if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type != 'range'){
                                let optionObj = op.values.find(e=>e.value_id == fOpVal.type);
                                this.appliedSizeLabel = optionObj.value;
                            }else if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type == 'range'){
                                this.sizeMin = fOpVal.from_value ? fOpVal.from_value:"";
                                this.sizeMax = fOpVal.to_value ? fOpVal.to_value : "";
                                this.sizeUnit = fOpVal.unit;

                                const hasMin = this.sizeMin !== '';
                                const hasMax = this.sizeMax !== '';

                                if (!hasMin && !hasMax) {
                                    this.appliedSizeLabel = '';
                                    alert(this.$t('Please enter either minimum size or maximum size'));
                                    return;
                                }

                                if (hasMin && hasMax && Number(this.sizeMax) < Number(this.sizeMin)) {
                                    this.appliedSizeLabel = '';
                                    alert(this.$t('From value cannot be greater than To value'));
                                    return;
                                }

                                const minLabel = hasMin ? `${this.sizeMin} ${this.sizeUnit}` : `0 ${this.sizeUnit}`;
                                const maxLabel = hasMax ? `${this.sizeMax} ${this.sizeUnit}` : this.$t("Onwards");

                                this.appliedSizeLabel = `${minLabel} – ${maxLabel}`;
                            }
                        }else {
                            let valOp = op.values.filter(e=>e.value_id == fOpVal)
                            if(valOp.length > 0){
                                this.singlePicklistMapper[op.key] = valOp[0]
                            }
                        }
                        this.completeFormData[op.key] = fOpVal
                    }
                    if(entrySelected){
                        let selOp = Object.assign({},op);
                        selOp["checked"] = true;
                        this.selectedFiltersList.push(selOp)
                    }
                }
                for(let gop of this.globalFilters){
                    if(gop.key && ['created_on'].includes(gop.key)){
                        if(this.routeQuery[gop.key]){
                            let indexC = gop.values.findIndex(e => e.value_id == this.routeQuery[gop.key].type);
                            this.selectedCreatedDateValue = gop.values[indexC];
                            // if(this.routeQuery[gop.key].value){
                            //     this.createdDateCustomFilterValSingleVal = this.routeQuery[gop.key].value;
                            // }
                            // else
                            if(this.routeQuery[gop.key].from_value && this.routeQuery[gop.key].to_value && this.selectedCreatedDateValue.value_id == 'range'){
                                this.createdDateCustomFilterVal = [this.routeQuery[gop.key].from_value, this.routeQuery[gop.key].to_value];
                            }else if(this.routeQuery[gop.key].from_value && this.routeQuery[gop.key].to_value && this.selectedCreatedDateValue.value_id == 'year_range'){
                                this.createdDateCustomFilterValForYearRange = [this.routeQuery[gop.key].from_value, this.routeQuery[gop.key].to_value];
                            }
                            else{
                                for(let cType of ["to_value","value","from_value"]){
                                    if(cType in this.routeQuery[gop.key]){
                                        this.createdDateCustomFilterValSingleVal = this.routeQuery[gop.key][cType];
                                        break;
                                    }
                                }
                            }
                            // else if(this.routeQuery[gop.key].from_value){
                            //     this.createdDateCustomFilterValSingleVal = this.routeQuery[gop.key].from_value;
                            // }
                        }else{
                            this.selectedCreatedDateValue = {};
                        }
                    }
                    if(gop.key && ['mime_type'].includes(gop.key)){
                        if(this.routeQuery[gop.key] && 'mime_type' in this.routeQuery){
                            let tempArr = [];
                            let routeMimeType = this.routeQuery['mime_type']
                            let tempMimeType = []
                            if(typeof(routeMimeType) == 'string'){
                                tempMimeType = JSON.parse(routeMimeType)
                            }else{
                                tempMimeType = JSON.parse(JSON.stringify(routeMimeType))
                            }
                            for(let t=0;t<tempMimeType.length;t++){
                                let index = gop.values.findIndex(e=>e.value_id == tempMimeType[t]);
                                if(index > -1){
                                    tempArr.push(gop.values[index])
                                }
                            }
                            this.selectedMimeTypeValue = tempArr;
                        }else{
                            this.selectedMimeTypeValue = []
                        }
                    }
                }
            }
        },
        ...mapActions("search", ["getSearchActionsFromServer"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapGetters("users",["getLoggedInUserType"]),
        ...mapGetters("queryBuilder", ["getQueryBuiderTypes", "getQueryBuiderQueryParamters", "getColumnsRequiredInQueryBuilderReport"]),
    },
    watch: {
        appliedValues(newVal){
            if(newVal)this.valuesToBePopulated = newVal;
            this.reloadRouteFilters();
            this.getfiltersListOnContext(this.searchContext);
        },
        'searchContext': function (val) {
            if(val){
                this.getfiltersListOnContext(this.searchContext);
            }
        },
        'searchContextPaylod':function(val){
            if(val && this.searchContext == 'query-builder-in-reports'){
                this.getfiltersListOnContext(this.searchContext);
            }
        },
        globalFilters(){
            let aiFilters = this.globalFilters.find(op=>op.key == 'ai_plugin');
            if(aiFilters){
                this.findInFilterList = this.findInFilterList.concat(aiFilters.values);
                this.reloadRouteFilters();
            }
            let pagesFilters = this.globalFilters.find(op=>op.key == 'pages_plugin');
            if((!this.pluginSpecificSearchInFilters || this.pluginSpecificSearchInFilters.length == 0) && pagesFilters){
                this.findInFilterList = this.findInFilterList.concat(pagesFilters.values);
                this.reloadRouteFilters();
            }
            if(this.pluginSpecificSearchInFilters && this.pluginSpecificSearchInFilters.length > 0){
                this.findInFilterList = this.pluginSpecificSearchInFilters;
                this.reloadRouteFilters();
            }
        }
        
    },
    mounted(){
       setTimeout(() => {
        this.show = true;
        }, 200);
    },
    created(){
        this.$options.components['CatalogDropdown'] = CatalogDropdown
        this.registerforWebsocketNotifications()
        if(this.searchContext == 'query-builder-in-reports'){
            this.reloadRouteFilters();
        }
        this.getfiltersListOnContext(this.searchContext);
        if(this.barcodeInfoFromStartup.enable_reference_id_workflow && this.barcodeInfoFromStartup.alias){
            if(this.barcodeInfoFromStartup.alias.key_name == 'reference_id'){
                this.findInFilterList.push({"label":this.barcodeInfoFromStartup.alias.alias_name,"key":'reference_id'})
            }
        }

        if(this.pluginSpecificSearchInFilters && this.pluginSpecificSearchInFilters.length > 0){
            this.findInFilterList = this.pluginSpecificSearchInFilters;
        }

    },
    beforeDestroy(){
        this.unRegisterforWebsocketNotifications()
    }
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:22px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $applied-filter-background: #1c6c8e;
    $applied-filter-text-color: #eee;

    .focusTheField{
        outline: none;
        bottom: 0px;
        inset-inline-start:0px;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
    }

    .reset-button{
        display: flex;
        align-items: center;
        margin-inline-start: 6px;
        color: $secondary-text-color;
        border-inline-start: 1px solid #272727;
        height: 49px;
        padding-inline-start: 7px;
    }
    .reset-button:hover{
        text-decoration: underline;
    }
    .advanced-search-wrapper{
        height:auto;
        display: flex;
        flex-direction: row;
        .add-search-filter{
            width:auto;
            color: $active-blue;
            svg{
                color:$active-blue;
            }
        }
        .selected-filters-wrapper{
            list-style-type: none;
            display: inline-flex;
            flex-wrap: wrap;
            padding: 0px;
            width: 100%;
            justify-content: start;
            overflow: auto;
            .selected-filter{
                margin: 4px 0px;
                margin-inline-start: 10px;
                height: fit-content
            }
        }
    }
    .selected-filter{
        margin: 4px 0px;
        margin-inline-start: 10px;
    }
    textarea:focus{
        outline: none;
        bottom: 0px;
        inset-inline-start:0px;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
    }
    .comm-input-field-style{
        background: $primary-background !important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }
    .empty-field-text-styles{
        color:$none-text-color;
    }

    .input-field-wrapper{
        display: inline-flex;
        width: 100%;
        position: relative;
        svg{
        position: absolute;
        inset-inline-end: -27px;
        top: 12px;
        height:25px;
        }
    }

    .fields-on-non-edit-mode{
    width:100%;
    display:inline-flex;
    line-height:46px;
    }

    .bigger-checkboxes {
        height: 30px;
        width: 20px;
        position:relative;
    }
    input[type="checkbox"]:after {
        line-height: 1.5em;
        content: "";
        display: inline-block !important;
        width: 22px !important;
        height: 21px !important;
        margin-top: 5px !important;
        margin-inline-start: -1px !important;
        border: $border-color !important;
        border-radius: 0.25em !important;
        background: $primary-background !important;
    }
    input[type="checkbox"]:checked:after {
        content: "✔";
        color: $active-blue !important;
        position: absolute !important;
        font-size: 16px !important;
        line-height: 1 !important;
        transition: all 0.2s !important;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px !important;
        padding-top: 2px !important;
    }

    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }

    .tags-display-ul{
    list-style-type: none;
    }

    .tags-display-ul .show-tags-delete{
    visibility:hidden;
    }

    .searched-metadata-display-fields{
    height: auto;
    width: 90%;
    }

    .view-tags:hover .show-tags-delete{
    visibility: visible;
    }

    .view-tags:hover {
        border: $border-color !important;
    }

    .key-style {
    color: $dull-text-color;
    width: 30%;
    text-align: center;
    font-size: $input-field-and-label-font-size;
    padding-inline-start: 5px;
    padding-inline-end: 5px;
    margin-top: 13px;
    }

    .activeTag{
        color: $active-blue !important;
    }
    .view-tags{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border: $border-color !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: center;
        width:auto !important;
        padding-inline-start: 12px !important;
        justify-content: center;
        padding-top: 1px !important;
        div{
                padding: 0px 8px;
                margin-inline-start: 0px;
                font-size: 12px;
                border-radius: 15px !important;
                position: relative;
                top: 1px;
        }
    }

    .view-fields-styles{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: start;
        width:98% !important;
        padding-inline-start: 12px !important;
        justify-content: start;
        padding-top: 1px !important;
        div{
                padding: 0px 8px;
                margin-inline-start: 0px;
                font-size: 14px;
                line-height: 32px;
                color: $secondary-text-color;
                text-align:end;
        }
    }

    .comm-tags-field-wrapper-style{
        background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        min-height: $input-field-height;
        margin-top:1px;
        margin-bottom:1px;
        border-radius: 4px;
    }

    .comm-input-field-style:focus{
        outline:none !important;
        box-shadow: none !important;
    }
    ::v-deep{
    .mx-datepicker-popup{
        z-index:99999 !important;
    }
    .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
    .mx-input{
        background-color: $primary-background  !important;
        border: none !important;
        color: $text-color !important;
    }
    .mx-datepicker-main{
        border: $border-color !important;
        background: $secondary-background-color !important;
        z-index: 9999 !important;
    }
    .mx-calendar-content .cell:hover{
        background-color: $bg-color-on-hover !important;
    }
    .mx-datepicker-range{
        width:auto;
    }
    .mx-calendar-content .cell:hover {
        color: #000000;
        background-color: #7d99b1;
    }
    .mx-icon-calendar{
        color:$text-color;
    }
    .mx-input:focus{
        outline:none !important;
        box-shadow: none !important;
    }
    }

    .value-style{
    width: 98%;
    text-align: start;
    padding-top: 0px;
    padding-bottom: 3px;
    padding-inline-end: 5px;
    .slug-ellipsis{
        white-space: nowrap;
        max-width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    }
    .input-fields{
        border: none;
        border-radius: 0px !important;
        // margin-inline-start:5px;
        // margin-bottom: 7px;
    }

    .focusField{
        input:focus, select:focus{
        border:none !important;
    }
    }

    .tags-wrapper{
    position: absolute;
    inset-inline-end: 0px;
    }

    svg {
    color: #666666;
    }

    svg:hover {
    color: $text-color;
    }

    .table-scroll {
    /*width:100%; */
    border: none !important;
    /* Decoration */
    border-spacing: 0;
    width: 100%;
    thead {
        color: $dull-text-color !important;
        position: relative;
        th{
        position: sticky;
        top: 0;
        background: $primary-background;
        z-index:9;
        text-align: start;
        padding:0px;
        border:none;
        }
    }
    tbody {
        width: 100%;
        overflow: auto;
        font-weight: 500;
        tr{
        height:40px;
        border-bottom: 1px solid $primary-background;
        padding:0px;
        }
    }
    }


    .delete-btn {
        visibility: hidden;
    }
    .comm-table-row:hover .delete-btn {
        visibility: visible;
        position: relative;
        inset-inline-start:18px;
        vertical-align: top;
    }

    /* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
    }

    .height-set-for-component {
    height: calc(100% - 120px);
    }

    .comm-custom-range-fields{
        .dropdown {
            position: relative;
        }

        .dropdown-header {
            // background: #333;
            // border: 1px solid #444;
            border-radius: 4px;
            padding: 6px 14px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color:#fff;
        }

        .selected-value-div{
            color:#fff;
        }
        // .dropdown-header.active {
        //     border-color: #5f6cff;
        //     background: #1e2050;
        // }

        .arrow {
            border: solid #aaa;
            border-width: 0 2px 2px 0;
            padding: 3px;
            transform: rotate(45deg);
        }

        .dropdown-list {
            position: fixed;
            // position:absolute;
            width: 250px;
            text-align: start;
            background: #15181B !important;
            // border: 1px solid #444;
            border-radius: 4px;
            margin-top: 4px;
            z-index: 100;
        }

        .option {
            padding: 12px 16px;
            cursor: pointer;
            color:#eee;
        }

        .option:hover {
            background: #22272b;
        }

        .custom-row {
            padding: 12px 16px;
            border-top: 1px solid #444;
            cursor: pointer;
            color:#eee;
        }

        .custom-row:hover {
            background: #22272b;
        }

        .inputs {
            display: flex;
            gap: 8px;
            padding: 10px 16px;
            background: #15171b;
        }

        input, select {
            width: 100%;
            padding: 7px;
            background: #15171b;
            border: 1px solid #444;
            border-radius: 4px;
            color: #fff;
        }

        input:focus, select:focus {
            border-color: $active-blue;
            outline: none;
        }

        .actions {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            padding: 10px 16px 14px;
            background: #15171b;
            border-top: 1px solid #3a3a3a;
        }

        .btn {
            padding: 6px 14px;
            border-radius: 4px;
            font-size: 13px;
            cursor: pointer;
        }

        .btn.cancel {
            background: transparent;
            color: #6c757d;
            border: 1px solid #6c757d;
        }

        .btn.apply {
            background: $active-blue;
            color: #fff;
            border: none;
        }

        .clear-x {
            margin-inline-start: 10px;
            cursor: pointer;
            color: #999;
        }

        .clear-x:hover {
            color: #fff;
        }
    }


    ::v-deep{

    .apply-background{
        .mx-input-wrapper{
            display: flex;
            justify-content: flex-start;
            padding-inline-start: 12px;
            background: $applied-filter-background !important;
            color: $applied-filter-text-color !important;
        }
        .mx-datepicker-range{
            .mx-input-wrapper{
                padding-inline-start: 0px;
            }
        }
    }

    .catalog-filter{
        .multiselect{
            height:unset;
            min-height:30px;
            width:100% !important;
            .multiselect__single {
                padding-top: 3px !important;
                margin-bottom: 6px;
                top:5px !important;
            }
        }
    }
    .apply-background{
        background: $applied-filter-background !important;
        color: $applied-filter-text-color !important;
        border: 1px solid #229ed2 !important;
        .comm-input-field-style,.selected-tags-style, .multiselect__input, .tags-style{
            background: #156382 !important;
            color: $applied-filter-text-color !important;
        }
        .selected-tags-style, .tags-style{
            border: 1px solid #343434 !important;
        }
        .multiselect__tags, .mx-input{
            background: $applied-filter-background !important;
        }
        .multiselect__single, .mx-input, .mx-icon-calendar, .mx-icon-clear, button, svg{
            color: $applied-filter-text-color !important;
        }
        .remove-tag{
            svg{
                color: $applied-filter-text-color !important;
            }
        }
        .multiselect__select::before{
            border-color: #b8b8b8 transparent transparent !important;
        }
        .multiselect__placeholder, ::placeholder {
            color: #a6a6a6  !important;
        }
        svg{
            fill: #bababa
        }
    }
    
    .apply-background:hover{
        svg{
            fill: #eee;
        }
    }
    .multiselect__select{
        height: 30px;
    }

    // .multiselect__select::before{
    //     top:54%;
    // }
    .multi-tags-select, .single-selection{
        .multiselect__select::before{
            top:65%;
        }
    }

    .add-search-filter{
        display: inline-flex;
        border: 3px solid $border-color-only !important;
        .add-fileds-icon{
            position: absolute;
            inset-inline-start:10px;
            z-index: 99;
            top: 13px;
        }
        .multiselect{
            min-width:15%;
            margin: -2px 0px;
            .multiselect__tag{
                display:none;
            }
            .multiselect__select{
                display:none;
            }
        }
    }
    .multiselect{
            width:100%;
            margin: 3px 0px;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            padding: 1px 40px 0 8px !important;
        }
        .multiselect__placeholder {
            padding-top: 4px !important;
            margin-bottom:0px;
            color:#5d5d5d !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 30px;
        }
        .multiselect__single{
            padding-top:3px !important;
            margin-bottom: 6px;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: fixed !important;
            display: block;
            background: $primary-background !important;
            width: 18% !important;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $primary-background !important;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background !important;
            height: auto !important;
            min-height: 30px !important;
        }
        .add-search-filter{
            .multiselect__tags {
                min-height: 29px;
            }
        }
        .filter-wrapper{
            display:inline-flex;
            align-items: center;
            border: $border-color;
            border-radius: 5px;
            background: $primary-background ;
            color:$dull-text-color;
            // height:35px;
            .filter-label{
                margin:0px 4px;
                width: auto;
                white-space: nowrap;
                padding-inline-start:4px;
            }
            .comm-input-field-style,.multiselect__tags{
                border: none !important;
                border-radius: none !important;
            }
            .mx-input{
                height:22px;
            }
            .multiselect{
                margin:0px !important;
            }
        }
    }

    .browse-icon{
        position: relative;
        inset-inline-start:8px;
        top: 3px;
    }

    .table td, .table th {
        border-top: none;
        padding:0px;
    }

    .display-as-tags{
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: start;
        float: inline-start;
    }

    .select-catalog-field{
        width: 101%;
        .value-style{
        width:100%;
        }
    }

    .editIconClass{
    visibility: hidden;
    }

    .comm-screen-profile-fields:hover{
    .editIconClass{
        visibility: visible;
        margin-inline-start: 8px;
    }
    }

    .user-name-or-image-in-selected-option{
    border: $border-color;
    height: 27px;
    width: 27px;
    border-radius: 5px;
    text-align: center;
    line-height: 26px;
    text-transform: uppercase;
    margin-top: -1px;
    margin-inline-start: -1px;
    }

    .tags-style{
        display: inline-flex;
        margin-inline-end: 5px;
        margin-bottom: 5px;
        height: 27px;
        margin-inline-start: 3px;
        float:inline-start;
    .user-name-display-as-tags{
        line-height: 27px;
        margin: 0px 5px;
        width:auto;
    }
    }

    .comm-field-wrapper{
        padding:5px;
        vertical-align: top;
    }

    .select-action-styles{
        margin-inline-end:10px;
        position: relative;
        top: 5px;
        width: 35% !important;
    }

    .primary-btn-style{
        margin-top:1%;
        height:70px;
        display:inline-flex !important;
        flex-wrap: nowrap !important;
        margin-inline-start:4px;
        button{
            height: 37px !important;
            border-radius: 5px;
            width: 100px;
            font-size:14px;
        }
    }
    .action-select-dropdown{
        width: 36% !important;
        margin-inline-end: 9px;
    }

    .selected-tags-style{
        background: $bg-color-on-hover;
        border: 1px solid #363636;
        border-radius: 15px;
        font-size: 12px !important;
        min-height: 25px !important;
        display: inline-flex !important;
        margin: 2px !important;
        border-radius: 15px !important;
        min-width: 50px !important;
        padding: 0px !important;
        text-align: center;
        width: auto !important;
        padding-inline-start: 12px !important;
        justify-content: center;
        padding-top: 2px !important;
        padding-inline-end: 4px !important;
        .remove-tag{
            line-height:18px;
            color: #858585;
        }
        }


</style>